const config = {
    apiBaseUrl: 'https://forms.central.edu.gh/eligibility',
  };
  
  export default config;